import React,{ useState,useEffect} from 'react'
import MasterCard from '../PaymentGateways/MasterCard';
import CCAvenue from '../PaymentGateways/CCAvenue'
import { Link } from 'react-router-dom';
import UpayGateway from '../PaymentGateways/UpayGateway';
import AmazonPay from '../PaymentGateways/AmazonPay';
import BankDhofar from '../PaymentGateways/BankDhofar';
import { salesforceSendFormNumber } from '../../actions/StudentAction';
import NGenius from '../PaymentGateways/NGenius';


const FeePaymentManage = ({feeDetail,userDetail}) => {
    const {installment,lumpsum,currency_code,net_payable_amount,
        payment_gateway,scholarship_amount,scholarship_percentage,total_fee,is_lumpsum,is_custum_lumpsum} = feeDetail !==undefined && feeDetail

    const [showPaymentOptions, setShowPaymentOptions] = useState(false);
    const [paymentAmountDetail,setPaymentAmountDetail] = useState(undefined);
    const [payType,setPayType] = useState('');
    const [lumpsumCheck,setLumpsumCheck] = useState(true);
    const [installmentCheck,setInstallmentCheck] = useState(false);

   useEffect(() => {
    if(is_lumpsum ===1){

      

        const installmentHandler = (instData,payType) => {
            setPaymentAmountDetail({
            instData,netpayable_amount:net_payable_amount,scholarship_amount,scholarship_percentage,total_fee,pay_type:2})
        }
        installmentHandler(
        {name: 'lumpsum',
        installment_type: 'lumpsum',
        amount: lumpsum?.amount,
        installment_id: 0,
        installment_number: 0
        }
        )
    }
    
    
   },[lumpsum,net_payable_amount])

    const handleCheckboxChange = () => {
        setShowPaymentOptions(!showPaymentOptions)
    }    
    const installmentHandler = (instData,payType) => {
        if(payType===1){
            // Installment
            setLumpsumCheck(false)
            setInstallmentCheck(true)
        }
        if(payType===2){
            // lumpsum
            setLumpsumCheck(true)
            setInstallmentCheck(false)
        }
        setPaymentAmountDetail({instData,netpayable_amount:net_payable_amount,scholarship_amount,scholarship_percentage,total_fee,pay_type:payType})
    }

    let superscriptData = ['','st','nd','rd','th','th','th','th','th','th']

    // const salesForceHandler = async() => {
    //     await salesforceSendFormNumber({form_num:userDetail?.form_num,status:'payment_initiated'})
    // }
  return (
    <>  
      
        <div className="choose_fee_options flex-wrap mt-2">
            {(installment?.length > 0 || lumpsum) && 
            <>
            {(userDetail?.pending_approve > 0 || userDetail?.pending_approve ==null) &&
            <h6 className="mt-3 mb-3 d-block w-100">Choose Payment Options</h6>}

            {/*Choose Lumpsum  */}
            {is_lumpsum ===1   &&
            <>
            {/* <input type="radio" disabled={lumpsum?.is_paid ===1} name="payType" value='' onChange={e => {}} defaultChecked={is_lumpsum ===1}  id="lumpsump_check"/> */}
            <div  className={`label lump_sum_label ${lumpsum?.is_paid ===1? 'lumpsum_paid':''}`}>
                <h5>Lumpsum Payment Plan</h5>
                {lumpsum?.is_paid ===0 ?
                <div className={`payment_plan_amount ${lumpsumCheck ? 'lumpsum_active':null} ${(lumpsum?.is_paid ===1 && lumpsum?.verification_status ===0) ? 'approval_pending_box':''} ${lumpsum.is_paid === 1 && lumpsum.verification_status ===1 ? 'paid_installment' :''}`}
                    onClick={e => {
                        installmentHandler({
                        name: 'lumpsum',
                        installment_type: 'lumpsum',
                        amount: lumpsum?.amount,
                        installment_id: 0,
                        installment_number: 0,
                        },2);
                    // setPayType(1);
                  }}>
                    <p>Lumpsum Amt.</p>
                    <h3>{lumpsum?.amount} {currency_code}</h3>
                    {(lumpsum?.verification_status ===0 || lumpsum?.verification_status ===1 ) &&<h6 className={`mt-1 ${(lumpsum?.is_paid ===1 && lumpsum?.verification_status ===0) ? 'approval_pending':''}`}>{(lumpsum?.is_paid ===1 && lumpsum?.verification_status ===1) && 'Paid'} {(lumpsum?.is_paid ===1 && lumpsum?.verification_status ===0) && 'Approval Pending' }</h6>}
                </div>
                :
                <div className={`payment_plan_amount  ${(lumpsum?.is_paid ===1 && lumpsum?.verification_status ===0) ? 'approval_pending_box':''} ${lumpsum.is_paid === 1 && lumpsum.verification_status ===1 ? 'paid_installment' :''}`}>
                    <p>Lumpsum Amt.</p>
                    <h3>{lumpsum?.amount} {currency_code}</h3>
                    {(lumpsum?.verification_status ===0 || lumpsum?.verification_status ===1 ) &&<h6 className={`mt-1 ${(lumpsum?.is_paid ===1 && lumpsum?.verification_status ===0) ? 'approval_pending':''}`}>{(lumpsum?.is_paid ===1 && lumpsum?.verification_status ===1) && 'Paid'} {(lumpsum?.is_paid ===1 && lumpsum?.verification_status ===0) && 'Approval Pending' }</h6>}
                </div>
                }
            </div>
            </>
            }


            {/*Choose Installment  */}
            {(installment?.length > 0  && is_custum_lumpsum !==1) && 
            <>
            {/* <input type="radio" name="payType" value=''   onChange={e => {}}  id="installment_check" /> */}
            <div className='label installment_label'>
                <h5>Installment Payment Plan</h5>
                <div className="d-flex flex-wrap">
                    {installment?.map((item,index) => {
                          let shouldApplyClass = false;

                          if (index === 0) {
                            // For the first installment, apply the class if both conditions are met
                            shouldApplyClass = (item.is_paid === 0 && item.verification_status === 0);
                          } 
                          
                          else if (
                            (item.is_paid === 1 || item.verification_status === 0) &&
                            ((installment!==undefined&& installment[index - 1].is_paid === 1) && (installment !==undefined &&installment[index - 1].verification_status === 1))
                          ) {
                
                            shouldApplyClass = (item.is_paid === 0 && item.verification_status === 0);
                          }

                        return(
                            <div key={index}  onClick={shouldApplyClass ? () => installmentHandler(item, 1) : null} 
                            className={`payment_plan_amount ${installmentCheck ? 'installment_active':null} installment_default ${(item?.is_paid ===1 && item?.verification_status ===0) ? 'approval_pending_box':''} 
                            ${shouldApplyClass ? 'active_installment' : ''} ${item.is_paid === 1 && item.verification_status ==1 ? 'paid_installment' :''}`}>

                                    <p>{item.installment_number}<sup>{superscriptData[item.installment_number]}</sup> Installment Amt.</p>

                                <h3>{parseFloat(item.amount).toFixed(1)} {currency_code}</h3>
                               {item?.due_date && <small>Due Date - {item?.due_date}</small>}
                               {(item?.verification_status ===0 || item?.verification_status ===1 ) &&<h6 className={`mt-1 ${(item?.is_paid ===1 && item?.verification_status ===0) ? 'approval_pending':''}`}>{(item?.is_paid ===1 && item?.verification_status ===1) && 'Paid'} {(item?.is_paid ===1 && item?.verification_status ===0) && 'Approval Pending' }</h6>}
                            </div>

                        )
                    })}
                    
                </div>
            </div>
            </>
            }
            </>
            }

        </div>
       
        
        {(paymentAmountDetail !==undefined && (userDetail?.pending_approve > 0 || userDetail?.pending_approve ==null)) && 
        <>
        {userDetail?.approval_pending !==1 &&
        <div className="payment_methods_contain">
            <div className="form-check mt-3">
                <input className="form-check-input" type="checkbox" id="flexCheckChecked" onChange={handleCheckboxChange} checked={showPaymentOptions} />
                <label className="form-check-label" htmlFor="flexCheckChecked">
                    I have read and agreed the company <a href="https://www.allenoverseas.com/refund-cancellation/" target='_blank' rel="noreferrer" className="text-secondary" title="Refund Policy">Refund policy</a> & <a href="https://www.allenoverseas.com/terms-and-conditions/" target='_blank' rel="noreferrer" className="text-secondary" title="Terms & Conditions">Terms & Conditions</a>
                </label>
            </div>
            <div className="payment_info mt-2 mb-2">
                To enable payment option you will need to check and agree to our company refund policy & terms conditions
            </div>
             
            <div className={`payment_methods mt-3 ${showPaymentOptions && 'enable_payments'}`}>
                {payment_gateway?.length > 0 ?

                    payment_gateway?.map((item) => (
                        <>
                            {(item.name ==='Master card' || item.name ==='Master Card') && feeDetail !== undefined && feeDetail !== null &&
                            <MasterCard 
                            key={item.id}
                            paymentConfig={item} 
                            userDetail={userDetail !==undefined && userDetail} 
                            selectedMethodFeeDetail={paymentAmountDetail !==undefined && paymentAmountDetail}/>}

                        {(item.name ==='Upay' || item.name ==='upay') && feeDetail !== undefined && feeDetail !== null &&
                            <UpayGateway 
                            key={item.id}
                            paymentConfig={item} 
                            userDetail={userDetail !==undefined && userDetail} 
                            selectedMethodFeeDetail={paymentAmountDetail !==undefined && paymentAmountDetail}/>}

                            {item.name ==='CCavenue' && feeDetail !== undefined && feeDetail !== null && 
                            <CCAvenue 
                            key={item.id}
                                paymentConfig={item} 
                                userDetail={userDetail !==undefined && userDetail} 
                                selectedMethodFeeDetail={paymentAmountDetail !==undefined && paymentAmountDetail}
                                feeDetail={feeDetail !==undefined && feeDetail}
                            />
                            }

                            {item.name ==='N-Genius' && feeDetail !== undefined && feeDetail !== null && 
                            <NGenius 
                            key={item.id}
                                paymentConfig={item} 
                                userDetail={userDetail !==undefined && userDetail} 
                                selectedMethodFeeDetail={paymentAmountDetail !==undefined && paymentAmountDetail}
                                feeDetail={feeDetail !==undefined && feeDetail}
                            />
                            }

                            {item.name ==='Bank Dofar' && feeDetail !== undefined && feeDetail !== null && 
                            <BankDhofar 
                            key={item.id}
                                paymentConfig={item} 
                                userDetail={userDetail !==undefined && userDetail} 
                                selectedMethodFeeDetail={paymentAmountDetail !==undefined && paymentAmountDetail}
                                feeDetail={feeDetail !==undefined && feeDetail}
                            />
                            }

                            {item.name ==='Amazon payment services' && feeDetail !== undefined && feeDetail !== null && 
                            <AmazonPay 
                            key={item.id}
                                paymentConfig={item} 
                                userDetail={userDetail !==undefined && userDetail} 
                                selectedMethodFeeDetail={paymentAmountDetail !==undefined && paymentAmountDetail}
                                feeDetail={feeDetail !==undefined && feeDetail}
                            />
                            }   
                        </>
                        )
                    )

                 : <h5 className='text-center'>No Payment Gateway Found</h5>
                }

                {/* {feeDetail !== undefined && feeDetail !== null && 
                <Link to={`/student/bank-transfer/${userDetail?.id}/${paymentAmountDetail?.pay_type}/${paymentAmountDetail?.instData?.installment_number}`}   className='banktransfer_btn text-decoration-none'>Cheque/POS/Post-Dated Cheque</Link>} */}

            </div>
            
        </div>
        }
        </>
        }

    </>
  )
}

export default FeePaymentManage